import { render, staticRenderFns } from "./ManageShotsModal.vue?vue&type=template&id=812a5366&scoped=true&"
import script from "./ManageShotsModal.vue?vue&type=script&lang=js&"
export * from "./ManageShotsModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageShotsModal.vue?vue&type=style&index=0&id=812a5366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812a5366",
  null
  
)

export default component.exports